module.exports = __webpack_public_path__ + "static/media/gallery20.dbb8dc94.png";